import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { Reveal, Label } from "./Reveal";
import { TESTIMONIALS } from "../data";

export default function Testimonials() {
  const [idx, setIdx] = useState(0);
  const t = TESTIMONIALS[idx];
  const go = (dir) =>
    setIdx((v) => (v + dir + TESTIMONIALS.length) % TESTIMONIALS.length);

  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="bg-obsidian py-24 lg:py-32 border-b border-border"
    >
      <div className="max-w-[1600px] mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between mb-14">
          <Label>Client Voices</Label>
          <div className="flex items-center gap-2">
            <button
              data-testid="testimonial-prev"
              onClick={() => go(-1)}
              className="w-12 h-12 border border-border flex items-center justify-center text-white hover:bg-acid hover:text-obsidian hover:border-acid transition-colors"
              aria-label="Previous testimonial"
            >
              <ArrowLeft size={18} />
            </button>
            <button
              data-testid="testimonial-next"
              onClick={() => go(1)}
              className="w-12 h-12 border border-border flex items-center justify-center text-white hover:bg-acid hover:text-obsidian hover:border-acid transition-colors"
              aria-label="Next testimonial"
            >
              <ArrowRight size={18} />
            </button>
          </div>
        </div>

        <AnimatePresence mode="wait">
          <motion.blockquote
            key={idx}
            data-testid="testimonial-quote"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
            className="max-w-5xl"
          >
            <p className="font-display uppercase tracking-tight text-2xl sm:text-4xl lg:text-5xl leading-[1.05] text-white">
              <span className="text-acid">“</span>
              {t.quote}
              <span className="text-acid">”</span>
            </p>
            <footer className="mt-10 flex flex-wrap items-center gap-x-8 gap-y-2 border-t border-border pt-6">
              <span className="text-white uppercase tracking-[0.15em] text-sm font-semibold">
                {t.name}
              </span>
              <span className="text-zinc-500 text-sm">{t.company}</span>
              <span className="ml-auto text-acid text-xs uppercase tracking-[0.2em]">
                {t.meta}
              </span>
            </footer>
          </motion.blockquote>
        </AnimatePresence>

        <div className="mt-10 flex gap-2">
          {TESTIMONIALS.map((_, i) => (
            <button
              key={i}
              onClick={() => setIdx(i)}
              className={`h-1 transition-all duration-300 ${
                i === idx ? "w-12 bg-acid" : "w-6 bg-zinc-700"
              }`}
              aria-label={`Go to testimonial ${i + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
